module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    attrs: {
      "id": "page__auto"
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "label": "Тип",
      "name": "type",
      "id": "type",
      "data-vv-as": " ",
      "data-vv-name": "type",
      "error": _vm.errors.first('type')
    },
    model: {
      value: (_vm.auto.type),
      callback: function($$v) {
        _vm.$set(_vm.auto, "type", $$v)
      },
      expression: "auto.type"
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(" Не установленно ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v(" Автофургон ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v(" Тягач ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v(" Прицеп ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v(" Открытое авто ")])]), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:11'),
      expression: "'required|min:1|max:11'"
    }],
    staticClass: "col-6",
    attrs: {
      "label": _vm.numberLabel,
      "name": "number",
      "id": "number",
      "error": _vm.errors.first('number'),
      "data-vv-name": "number",
      "data-vv-as": ' ',
      "mask": "A 999 AA 99",
      "placegolder": "A 999 AA 99"
    },
    model: {
      value: (_vm.auto.number),
      callback: function($$v) {
        _vm.$set(_vm.auto, "number", $$v)
      },
      expression: "auto.number"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:1|max:50'),
      expression: "'min:1|max:50'"
    }],
    staticClass: "col-6",
    attrs: {
      "name": "brand",
      "id": "brand",
      "label": "Марка",
      "error": _vm.errors.first('brand'),
      "data-vv-name": "brand",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.auto.brand),
      callback: function($$v) {
        _vm.$set(_vm.auto, "brand", $$v)
      },
      expression: "auto.brand"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('integer|min:0|max:9999'),
      expression: "'integer|min:0|max:9999'"
    }],
    staticClass: "col-6",
    attrs: {
      "name": "max_seats",
      "id": "max_seats",
      "label": "Макс. кол-во мест",
      "error": _vm.errors.first('max_seats'),
      "data-vv-name": "max_seats",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.auto.max_seats),
      callback: function($$v) {
        _vm.$set(_vm.auto, "max_seats", $$v)
      },
      expression: "auto.max_seats"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('decimal|min:0|max:9999'),
      expression: "'decimal|min:0|max:9999'"
    }],
    staticClass: "col-6",
    attrs: {
      "name": "max_weight",
      "id": "max_weight",
      "label": "Макс. вес (грузоподъемность)",
      "error": _vm.errors.first('max_weight'),
      "data-vv-name": "max_weight",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.auto.max_weight),
      callback: function($$v) {
        _vm.$set(_vm.auto, "max_weight", $$v)
      },
      expression: "auto.max_weight"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('decimal|min:0|max:9999'),
      expression: "'decimal|min:0|max:9999'"
    }],
    staticClass: "col-6",
    attrs: {
      "name": "max_volume",
      "id": "max_volume",
      "label": "Макс. объём",
      "error": _vm.errors.first('max_volume'),
      "data-vv-name": "max_volume",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.auto.max_volume),
      callback: function($$v) {
        _vm.$set(_vm.auto, "max_volume", $$v)
      },
      expression: "auto.max_volume"
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-280d8c32","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/views/Auto.vue
// module id = 1078
// module chunks = 0